const e = "af.filter-sidebar.tag-toggled", t = class t extends CustomEvent {
  constructor(a) {
    super(e, { detail: { tag: a }, bubbles: !0, composed: !0 });
  }
};
t.EVENT_NAME = e;
let s = t;
export {
  e as EVENT_NAME,
  s as default
};
//# sourceMappingURL=TagToggleEvent.js.map
